import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TConfirmedOrdersResponsePayload,
	TOrderDiscountsResponsePayload,
	TOrdersStore,
	TReturnedOrdersResponsePayload,
	TOrderDetailsResponsePayload,
	TOrderReturnBreakdownResponsePayload,
	TOrderDiscountBreakdownResponsePayload,
	TOrderReturnItemsResponsePayload,
	TOrderDiscountItemsResponsePayload,
	TVatAndEASFeeResponsePayload,
	TOrderVatCorrectionsBreakdownResponsePayload,
	TOrderDetailsCombinedResponsePayload,
} from './types';

export const getOrdersState = (state: TStoreState): TOrdersStore => state.orders;

export const getOrders = getOrdersState;

// ==========================================:

export const getConfirmedOrders = createSelector(
	[getOrders],
	(orders: TOrdersStore): TConfirmedOrdersResponsePayload => orders.confirmedOrders,
);

// ==========================================:

export const getConfirmedOrdersLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.confirmedOrdersLoader,
);

// ==========================================:

export const getConfirmedOrdersForFilterId = createSelector(
	[getOrders],
	(orders: TOrdersStore): TConfirmedOrdersResponsePayload => orders.confirmedOrdersForFilterId,
);

// ==========================================:

export const getConfirmedOrdersForFilterIdLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.confirmedOrdersForFilterIdLoader,
);

// ==========================================:

export const getReturnedOrders = createSelector(
	[getOrders],
	(orders: TOrdersStore): TReturnedOrdersResponsePayload => orders.returnedOrders,
);

// ==========================================:

export const getReturnedOrdersLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.returnedOrdersLoader,
);

// ==========================================:

export const getOrderDiscounts = createSelector(
	[getOrders],
	(orders: TOrdersStore): TOrderDiscountsResponsePayload => orders.orderDiscounts,
);

// ==========================================:

export const getOrderDiscountsLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.orderDiscountsLoader,
);

// ==========================================:

export const getOrderDetails = createSelector(
	[getOrders],
	(orders: TOrdersStore): TOrderDetailsResponsePayload => orders.orderDetails,
);

// ==========================================:

export const getOrderDetailsLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.orderDetailsLoader,
);

// ==========================================:

export const getOrderDetailsCombined = createSelector(
	[getOrders],
	(orders: TOrdersStore): TOrderDetailsCombinedResponsePayload => orders.orderDetailsCombined,
);

// ==========================================:

export const getOrderDetailsCombinedLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.orderDetailsCombinedLoader,
);

// ==========================================:

export const getOrderReturnBreakdown = createSelector(
	[getOrders],
	(orders: TOrdersStore): TOrderReturnBreakdownResponsePayload => orders.orderReturnBreakdown,
);

// ==========================================:

export const getOrderReturnBreakdownLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.orderReturnBreakdownLoader,
);

// ==========================================:

export const getOrderDiscountBreakdown = createSelector(
	[getOrders],
	(orders: TOrdersStore): TOrderDiscountBreakdownResponsePayload => orders.orderDiscountBreakdown,
);

// ==========================================:

export const getOrderDiscountBreakdownLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.orderDiscountBreakdownLoader,
);

// ==========================================:

export const getOrderReturnItems = createSelector(
	[getOrders],
	(orders: TOrdersStore): TOrderReturnItemsResponsePayload => orders.orderReturnItems,
);

// ==========================================:

export const getOrderReturnItemsLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.orderReturnItemsLoader,
);

// ==========================================:

export const getOrderDiscountItems = createSelector(
	[getOrders],
	(orders: TOrdersStore): TOrderDiscountItemsResponsePayload => orders.orderDiscountItems,
);

// ==========================================:

export const getOrderDiscountItemsLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.orderDiscountItemsLoader,
);

// ==========================================:

export const createOrderReturnLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.createOrderReturnLoader,
);

// ==========================================:

export const createOrderDiscountLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.createOrderDiscountLoader,
);

// ==========================================:

export const getVatAndEASFee = createSelector(
	[getOrders],
	(orders: TOrdersStore): TVatAndEASFeeResponsePayload => orders.vatAndEASFee,
);

// ==========================================:

export const getVatAndEASFeeLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.vatAndEASFeeLoader,
);

// ==========================================:

export const getOrderVatCorrectionsBreakdown = createSelector(
	[getOrders],
	(orders: TOrdersStore): TOrderVatCorrectionsBreakdownResponsePayload =>
		orders.orderVatCorrectionsBreakdown,
);

// ==========================================:

export const getOrderVatCorrectionsBreakdownLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.orderVatCorrectionsBreakdownLoader,
);
